/**
 * Timing Constants
 * Centralized timing values used throughout the application.
 */

/**
 * Debounce delay for search inputs and other user interactions.
 * Used to reduce API calls while user is typing.
 */
const DEBOUNCE_MS = 300

/**
 * Default delay before showing tooltips.
 */
const TOOLTIP_DELAY_MS = 300

/**
 * HTTP request timeout in milliseconds.
 */
const HTTP_TIMEOUT_MS = 30000

/**
 * Duration to show toast notifications (copy success, etc.)
 */
const TOAST_DURATION_MS = 2000

/**
 * URL sync debounce delay in milliseconds.
 */
const URL_SYNC_DEBOUNCE_MS = 300

/**
 * Scroll state check delay in milliseconds.
 */
const SCROLL_CHECK_DELAY_MS = 100

export {
  DEBOUNCE_MS,
  TOOLTIP_DELAY_MS,
  HTTP_TIMEOUT_MS,
  TOAST_DURATION_MS,
  URL_SYNC_DEBOUNCE_MS,
  SCROLL_CHECK_DELAY_MS,
}
